import {useState} from "react";
import {PlayerNameEdit} from "../PlayerNameEdit";
import {TicketToRidePlayerData} from "../../features/TicketToRidePlayerData";
import axios from "axios";

export const TicketToRidePlayerView = ({data, index, matchId, handleRemoteData, mutateLocalPlayer, isMajorUpdating, setIsMajorUpdating}) => {
	const [isEditingName, setIsEditingName] = useState(false)
	const [nameInput, setNameInput] = useState('');

	const setPlayerName = async (newName) => {
		const newPlayer = structuredClone(data);
		newPlayer.playerName = newName;
		mutateLocalPlayer(index, newPlayer);
		const response = await axios.patch(`/api/m/${matchId}`, {rpc: 'player_rename', playerGuid: data.guid, playerName: newName})
		handleRemoteData(response)
	}

	const adjustRouteCount = async (routeIndex, adjustAmount) => {
		const newPlayer = structuredClone(data);
		newPlayer.routes[routeIndex] += adjustAmount;
		mutateLocalPlayer(index, newPlayer);
		const response = await axios.patch(`/api/m/${matchId}`, {rpc: 'player_routes_operate', playerGuid: data.guid, routeIndex: routeIndex, routeValue: adjustAmount})
		handleRemoteData(response)
	}

	const addBonus = async (bonusValue) => {
		const newPlayer = structuredClone(data);
		newPlayer.bonuses.push(bonusValue);
		mutateLocalPlayer(index, newPlayer);
		const response = await axios.patch(`/api/m/${matchId}`, {rpc: 'player_bonus_append', playerGuid: data.guid, bonusValue: bonusValue})
		handleRemoteData(response)
	}

	const removeBonus = async (bonusIndex) => {
		const newPlayer = structuredClone(data);
		newPlayer.bonuses.splice(bonusIndex, 1);
		mutateLocalPlayer(index, newPlayer);
		const response = await axios.patch(`/api/m/${matchId}`, {rpc: 'player_bonus_remove', playerGuid: data.guid, bonusValue: bonusIndex})
		handleRemoteData(response)
	}

	const removePlayer = async () => {
		if (isMajorUpdating) {
			return;
		}

		setIsMajorUpdating(true);
		const response = await axios.patch(`/api/m/${matchId}`, {rpc: 'player_instance_remove', playerGuid: data.guid})
		handleRemoteData(response)
	}

	const modifyColor = async (colorValue) => {
		const newPlayer = structuredClone(data);
		newPlayer.playerColor = colorValue;
		mutateLocalPlayer(index, newPlayer);
		const response = await axios.patch(`/api/m/${matchId}`, {rpc: 'player_color_modify', playerGuid: data.guid, colorValue: colorValue})
		handleRemoteData(response)
	}

	const score = TicketToRidePlayerData.getScore(data);

	return (
		<div className="ttr-player-wrapper" style={{borderColor: data.playerColor}}>
			<div className="ttr-player-left-wrapper">
				<div className="ttr-player-info-wrapper">
					<div className="ttr-player-color" style={{backgroundColor: data.playerColor}}/>
					<p className="ttr-player-name">{data.playerName}</p>
					<button onClick={() => {
						setIsEditingName(!isEditingName);
						setNameInput('')
					}}>
						Edit
					</button>
					<PlayerNameEdit isEditing={isEditingName} setIsEditing={setIsEditingName} setPlayerName={setPlayerName} nameInput={nameInput} setNameInput={setNameInput} modifyColor={modifyColor}/>
					<button disabled={isMajorUpdating} onClick={() => removePlayer(index)}>
						Remove Player
					</button>
				</div>
				<p className="ttr-player-header">Routes</p>
				<div className="ttr-player-routes-wrapper">
					{data.routes.map((routeValue, i) => <TicketToRideRouteModule key={i} routeIndex={i} routeCount={data.routes[i]} adjustRouteCount={(adjustAmount) => adjustRouteCount(i, adjustAmount)}/>)}
				</div>
				<p className="ttr-player-header">Tickets & Bonuses</p>
				<TicketToRideBonusesModule bonuses={data.bonuses} addBonus={addBonus} removeBonus={removeBonus}/>
			</div>
			<div className="ttr-player-right-wrapper">
				<span>
					<div className="ttr-player-final-score-wrapper">
						<p className="ttr-player-final-score-value" style={{
							fontWeight: score >= 100 ? 'bold' : 'normal',
							fontStyle: score < 0 ? 'italic' : 'normal'
						}}>{score}</p>
					</div>
					<p className="ttr-player-final-score-trains">🚂 {TicketToRidePlayerData.getTrainCount(data)}</p>
				</span>
			</div>
		</div>
	);
}

const TicketToRideRouteModule = ({routeIndex, routeCount, adjustRouteCount}) => {
	return (
		<div className="ttr-route-button-wrapper">
			<button className="ttr-route-button-left" style={{color: routeCount > 0 ? 'inherit' : '#444', fontWeight: routeCount > 0 ? 'bold' : 'normal'}} disabled={routeCount <= 0} onClick={() => adjustRouteCount(-1)}>{routeCount}</button>
			<button className="ttr-route-button-right" onClick={() => adjustRouteCount(1)}>
				🚂x{routeIndex + 1} [+{TicketToRidePlayerData.getRouteScoreValue(routeIndex)}]
			</button>
		</div>
	);
}

const TicketToRideBonusesModule = ({bonuses, addBonus, removeBonus}) => {
	const [addValue, setAddValue] = useState('');

	const onSubmit = (e) => {
		e.preventDefault();
		const value = parseInt(addValue);
		if (!isNaN(value)) {
			addBonus(value);
		}
		setAddValue('');
	}

	return (
		<div className="ttr-player-bonus-values-wrapper">
			<form onSubmit={onSubmit}>
				<input value={addValue} onChange={e => setAddValue(e.target.value)}/>
				<button type="submit">
					Submit
				</button>
			</form>
			{bonuses.map((bonusValue, i) => <button key={i} style={{width: 40}} onClick={() => removeBonus(i)}>{bonusValue > 0 ? '+' : ''}{bonusValue}</button>)}
			<div className="ttr-player-bonus-values-wrapper">
			</div>
		</div>
	);
}